import React from 'react';
import { useTheme } from 'styled-components';

import Main from 'Elements/Main';
import Section from 'Elements/Section';

import Breadcrumbs, { BreadcrumbsProps } from 'Components/Breadcrumbs';
import Grid, { Col } from 'Components/Grid';
import SupportBlock from 'Components/SupportBlock';

import HeroBanner, { StaffHeroBannerProps } from 'Modules/HeroBanner/Staff';

export interface Props {
    breadcrumbs: BreadcrumbsProps;
    heroBanner: StaffHeroBannerProps;
    role: {
        heading: string;
        content: React.ReactNode;
    };
    experience: {
        heading: string;
        content?: React.ReactNode;
    };
    qualifications: {
        heading: string;
        content?: React.ReactNode;
    };
    externalBodies: {
        heading: string;
        content?: React.ReactNode;
    };
    committeeMemberships: {
        heading: string;
        content?: React.ReactNode;
    };
}

const GovernorAndProfessional: React.FC<Props> = props => {
    const {
        heroBanner,
        breadcrumbs,
        role,
        experience,
        qualifications,
        externalBodies,
        committeeMemberships
    } = props;
    const { colors } = useTheme();

    return (
        <Main>
            <Breadcrumbs {...breadcrumbs} />
            <HeroBanner {...heroBanner} />
            <Section id="role-at-solent" background>
                <Grid>
                    <Col m={9} h={7}>
                        <h2>{role.heading}</h2>
                        {role.content}
                    </Col>
                </Grid>
            </Section>
            {experience.content && (
                <Section id="experience-and-qualifications" paddingTop={1}>
                    <Grid>
                        <Col m={9} l={7}>
                            <h2>{experience.heading}</h2>
                            {experience.content}
                        </Col>
                        {qualifications.content && (
                            <Col m={9} l={[9, 13]}>
                                <aside id="qualifications">
                                    <SupportBlock
                                        heading={qualifications.heading}
                                        backgroundColor={colors.secondary.tints[0].hex}
                                    >
                                        {qualifications.content}
                                    </SupportBlock>
                                </aside>
                            </Col>
                        )}
                    </Grid>
                </Section>
            )}
            {(committeeMemberships.content || externalBodies.content) && (
                <Section id="external-bodies-committee-memberships" background paddingTop={1}>
                    <Grid rowGap="1rem">
                        {externalBodies.content && (
                            <Col m={9} l={6}>
                                <SupportBlock heading={externalBodies.heading}>
                                    {externalBodies.content}
                                </SupportBlock>
                            </Col>
                        )}
                        {committeeMemberships.content && (
                            <Col m={9} l={6}>
                                <SupportBlock heading={committeeMemberships.heading}>
                                    {committeeMemberships.content}
                                </SupportBlock>
                            </Col>
                        )}
                    </Grid>
                </Section>
            )}
        </Main>
    );
};

export default GovernorAndProfessional;
